// extracted by mini-css-extract-plugin
export var card = "styles-module--card--1LGAu";
export var card_hr = "styles-module--card_hr--2fr7d";
export var card_title = "styles-module--card_title--MTG2v";